
import { media } from '../../../dataSets/media';
import { useContext, useLayoutEffect, useState } from "react";
import { DashboardContext } from "../../../contextApi/DashboardContext";
import { AppContext } from "../../../contextApi/ContextApi";

export default function Dashboard_Products_Item({ website, item, setEditPage }) {
  const { setCurrentProduct } = useContext(DashboardContext);
  const { fetchImage, primary_color, accent_color } = useContext(AppContext);
  const [moveToPageFlag, setMoveToPageFlag] = useState(false);
  const [imgUrl, setImgUrl] = useState();

  useLayoutEffect(()=>{
    fetchImage(website, item, setImgUrl);
  },[])

  const moveToProductPage = (item)=>{

    setCurrentProduct(item);
    window.scrollTo({
        top:0,
        'behavior':'smooth'
    });
    setEditPage(4);
  }
  return (
    <div className='dashboard_products_item' style={{backgroundColor:primary_color, color:accent_color}} dir='rtl' onMouseEnter={()=>{setMoveToPageFlag(true)}} onMouseLeave={()=>{setMoveToPageFlag(false)}}>
      
      {moveToPageFlag && <h4 className="dashboard_products_item_moveToPageBtn" onClick={()=>{moveToProductPage(item)}}>מעבר לעמוד מוצר</h4>}

      <img className="dashboard_products_item_img" src={imgUrl || website?.settings?.logo || media.webingoLogo} alt="product_logo" onClick={()=>{moveToProductPage(item)}}/>
      <div className="dasboard_products_item_details">
        <h5>שם המוצר: <span>{item.name}</span></h5>
        <h5>מחיר: <span>{item.price}₪</span></h5>
        <h5>יצרן: <span>{item.company}</span></h5>
        <h5>קטגוריה: <span>{item.categoryName}</span></h5>
        <h5>תיאור המוצר: <span>{item.desc.length > 65 ? `${item.desc.slice(0,65)}...` : item.desc}</span></h5>
      </div>
    </div>
  )
}
